'use strict';

var cov_20f15iqs6b = function () {
  var path = '/Users/ryanluton/Developer/divcon/divcon-tools/src/app/components/confirm-modal/confirm-modal.js',
      hash = '4eaf90ea83c7881d4c955bd5abb26c52ae652645',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/Users/ryanluton/Developer/divcon/divcon-tools/src/app/components/confirm-modal/confirm-modal.js',
    statementMap: {
      '0': {
        start: {
          line: 2,
          column: 0
        },
        end: {
          line: 31,
          column: 5
        }
      },
      '1': {
        start: {
          line: 3,
          column: 23
        },
        end: {
          line: 10,
          column: 3
        }
      },
      '2': {
        start: {
          line: 13,
          column: 17
        },
        end: {
          line: 13,
          column: 21
        }
      },
      '3': {
        start: {
          line: 15,
          column: 4
        },
        end: {
          line: 19,
          column: 6
        }
      },
      '4': {
        start: {
          line: 16,
          column: 6
        },
        end: {
          line: 18,
          column: 9
        }
      },
      '5': {
        start: {
          line: 21,
          column: 4
        },
        end: {
          line: 25,
          column: 6
        }
      },
      '6': {
        start: {
          line: 22,
          column: 6
        },
        end: {
          line: 24,
          column: 9
        }
      },
      '7': {
        start: {
          line: 28,
          column: 2
        },
        end: {
          line: 30,
          column: 45
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 2,
            column: 1
          },
          end: {
            line: 2,
            column: 2
          }
        },
        loc: {
          start: {
            line: 2,
            column: 13
          },
          end: {
            line: 31,
            column: 1
          }
        }
      },
      '1': {
        name: 'confirmModalCtrl',
        decl: {
          start: {
            line: 12,
            column: 11
          },
          end: {
            line: 12,
            column: 27
          }
        },
        loc: {
          start: {
            line: 12,
            column: 30
          },
          end: {
            line: 26,
            column: 3
          }
        }
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 15,
            column: 14
          },
          end: {
            line: 15,
            column: 15
          }
        },
        loc: {
          start: {
            line: 15,
            column: 20
          },
          end: {
            line: 19,
            column: 5
          }
        }
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 21,
            column: 18
          },
          end: {
            line: 21,
            column: 19
          }
        },
        loc: {
          start: {
            line: 21,
            column: 24
          },
          end: {
            line: 25,
            column: 5
          }
        }
      }
    },
    branchMap: {},
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0
    },
    b: {},
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

++cov_20f15iqs6b.s[0];
(function () {
  ++cov_20f15iqs6b.f[0];

  var confirmModal = (++cov_20f15iqs6b.s[1], {
    bindings: {
      close: '&',
      dismiss: '&'
    },
    templateUrl: 'app/components/confirm-modal/confirm-modal.html',
    controller: confirmModalCtrl
  });

  function confirmModalCtrl() {
    ++cov_20f15iqs6b.f[1];

    var self = (++cov_20f15iqs6b.s[2], this);

    ++cov_20f15iqs6b.s[3];
    self.ok = function () {
      ++cov_20f15iqs6b.f[2];
      ++cov_20f15iqs6b.s[4];

      self.close({
        $value: true
      });
    };

    ++cov_20f15iqs6b.s[5];
    self.cancel = function () {
      ++cov_20f15iqs6b.f[3];
      ++cov_20f15iqs6b.s[6];

      self.dismiss({
        $value: 'cancel'
      });
    };
  }

  ++cov_20f15iqs6b.s[7];
  angular.module('app').component('confirmModal', confirmModal);
})();

// $ctrl.openComponentModal = function () {
//   var modalInstance = $uibModal.open({
//     animation: $ctrl.animationsEnabled,
//     component: 'modalComponent',
//     resolve: {
//       items: function () {
//         return $ctrl.items;
//       }
//     }
//   });

//   modalInstance.result.then(function (selectedItem) {
//     $ctrl.selected = selectedItem;
//   }, function () {
//     $log.info('modal-component dismissed at: ' + new Date());
//   });